import axios from '@axios'

export default {
  listFormas: params => axios.get(
    `${process.env.VUE_APP_WCOND_API}/leitura/formas/${params.pagina}`,
  ),
  list: params => axios.get(
    `${process.env.VUE_APP_WCOND_API}/leituras/${params.formaLeitura}/${params.data}/${params.page}`,
  ),
  save: leitura => axios.post(
    `${process.env.VUE_APP_WCOND_API}/leitura`,
    leitura,
  ),
}
